export default function Operators() {
  return (
    <div className="text-center mt-5">
      <h1>Operadores</h1>
      <p>Esta sección está en construcción.</p>
    </div>
  );
}
